module.exports = __webpack_public_path__ + "front/img/68.a07a4a8a.jpg";